import { useLocation } from "react-router-dom";
import React, { useState, useRef, useEffect } from "react";
import ProfileCard from "./ProfileCard";
import "./Header.css"; // Assuming you have a CSS file for styling
import profileImage from "../assets/profile.jpeg"; // Import the image from the new location

export default function Header() {
    const location = useLocation();
    const [showProfile, setShowProfile] = useState(false);
    const profileRef = useRef(null);

    const routeTitles = {
        "/": "Dashboard",
        "/wildlife-threats": "Wildlife Threats",
        "/drone-streaming": "Drone Streaming",
        "/iot-sensing": "IoT Sensing",
        "/insights": "Insights",
        "/drone-map": "Drone Map",
        "/alert-settings": "Alert Settings",
        "/sign-out": "Sign Out",
    };

    const pageTitle = routeTitles[location.pathname] || "WildAsia";
    const pathSegments = location.pathname.split('/').filter(segment => segment);

    useEffect(() => {
        function handleClickOutside(event) {
            if (profileRef.current && !profileRef.current.contains(event.target)) {
                setShowProfile(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <div className="sticky top-0 right-0 h-16 flex items-center justify-between px-6 bg-white ml-[240px] z-20">
            {/* Left side - Breadcrumb */}
            <div className="flex items-center space-x-2 text-sm">
                <span className="text-gray-600">{pageTitle}</span>
            </div>

            {/* Right side - Profile */}
            <div className="relative" ref={profileRef}>
                <div className="flex items-center space-x-3 cursor-pointer" onClick={() => setShowProfile(!showProfile)}>
                    <img
                        src={profileImage}
                        alt="Profile"
                        className="w-8 h-8 rounded-full"
                        />
                    <div>
                        <p className="text-sm font-medium">Wildlife Officer</p>
                        <p className="text-xs text-gray-500">Mr. Pujitha Silva</p>
                    </div>
                </div>

                {showProfile && (
                    <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg py-2 z-30">
                        <ProfileCard onClose={() => setShowProfile(false)} />
                    </div>
                )}
            </div>
        </div>
    );
}